module.exports = __webpack_public_path__ + "img/smirnoff-black-russian.1ee381bf.jpg";